export default "__VITE_ASSET__b854b85e__"